import { Box } from '@mui/material'
import PermissionList from './PermissionList'
import { useMemo } from 'react'

function ModuleList({ role, modules, districtType, search }) {
  const filteredModules = useMemo(() => {
    const base = modules?.filter(m => m.types?.includes(districtType)) ?? []
    if (!search?.trim()) return base
    const q = search.toLowerCase()
    return base
      .map(module => ({
        ...module,
        permissions: module.permissions?.filter(p =>
          p.name?.toLowerCase().includes(q) ||
          p.description?.toLowerCase().includes(q)
        ),
      }))
      .filter(module =>
        module.name?.toLowerCase().includes(q) || module.permissions?.length > 0
      )
  }, [modules, districtType, search])

  return (
    <Box>
      {filteredModules.map(module => (
        <PermissionList
          key={module.id}
          role={role}
          module={module}
          districtType={districtType}
        />
      ))}
    </Box>
  )
}

export default ModuleList